import React, {createContext, useContext, useState, useCallback, useEffect} from 'react';
import {useHistory} from "react-router-dom";
import {isEqual, isFunction} from "lodash";
import * as generalActions from '../../_common/actions/generalData';

const ContactsContext = createContext('');

export function useContactsContext() {
  return useContext(ContactsContext);
}

export function ContactsProvider({children}) {
  const history = useHistory();
  const [queryParams, setQueryParamsBase] = useState({});
  const setQueryParams = useCallback(nextQueryParams => {
    setQueryParamsBase(prevQueryParams => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }
      for (let key in nextQueryParams) {
        if (nextQueryParams.hasOwnProperty(key) && !nextQueryParams[key]) delete nextQueryParams[key]
      }
      const path = history.location.pathname;
      const newQueryParams = new URLSearchParams(nextQueryParams);
      history.replace(`${path}?${newQueryParams.toString()}`);

      return nextQueryParams;
    });
  }, []);

  const [contactStatusTypes, setContactStatusTypes] = useState([]);
  useEffect(() => {
    generalActions.getContactStatusTypes()
      .then(setContactStatusTypes)
      .catch((e) => {
        console.error(e);
        setContactStatusTypes([]);
      });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    contactStatusTypes
  };

  return <ContactsContext.Provider value={value}>{children}</ContactsContext.Provider>;
}
